export const OpenDocIcon = (
<svg width="14" height="14" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.33333 6.33333H1.66667V1.66667H4V1H1.66667C1.29667 1 1 1.3 1 1.66667V6.33333C1 6.7 1.29667 7 1.66667 7H6.33333C6.7 7 7 6.7 7 6.33333V4H6.33333V6.33333ZM4.66667 1V1.66667H5.86333L2.58667 4.94333L3.05667 5.41333L6.33333 2.13667V3.33333H7V1H4.66667Z" fill="var(--YW_Citations_KB_Button_Color)"/>
</svg>
);
